export default __webpack_public_path__ + "static/media/025-stegosaurus.ba55f51e.svg";